import { Observable, Observer } from 'rxjs';

export class ParseObservable<T> extends Observable<T> {
  constructor(promise: Parse.Promise<T>) {
    super((observer: Observer<any>) => {
      promise.then(
        (result: T) => {
          observer.next(result);
          observer.complete();
        },
        error => {
          observer.error(error);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/services/parse-observable.ts